import React from 'react'
import { Divider, Modal, Button, Col, Row } from 'antd'
import { BulbOutlined, FrownOutlined, FallOutlined } from '@ant-design/icons'
import Prediction from './Prediction'
import disasterTraslations from '../core/data/disaster-translations.json';
import { getPrediction } from '../core/prediction';

const Region = ({
  isOpen,
  regionName,
  regionMetadata,
  regionMostProbableDisaster,
  onClose,
  showHistoricalDetailsModal
}) => {
  const [showPrediction, setShowPrediction] = React.useState(false);

  const displayInfo = region => {
    function formatUSD(number) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
    }

    return (
      <>
        <Divider />
        <Row justify='space-around'>
          <Col><BulbOutlined /> Evento mas recurrente: {disasterTraslations[regionMostProbableDisaster]}</Col>
        </Row>
        <Row justify='space-around'>
          <Col><FrownOutlined /> Personas Afectadas: {regionMetadata.totalAffected.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Col>
          <Col><FallOutlined /> Total de Daños: {formatUSD(regionMetadata.totalDamages)}</Col>
        </Row>
        <Divider />
      </>
    )
  }

  return (
    <>
      <Modal
        title={regionName}
        open={isOpen}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <Button key='back' onClick={onClose}>
            Cancelar
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              setShowPrediction(true)
            }}
          >
            Predecir
          </Button>,
          <Button
            key='submit2'
            type='primary'
            onClick={() => showHistoricalDetailsModal()}
          >
            Histórico
          </Button>
        ]}
      >
        {regionMetadata && displayInfo(regionMetadata)}
      </Modal>
      <Prediction
        isOpen={showPrediction}
        regionName={regionName}
        prediction={getPrediction(regionName)}
        onClose={() => setShowPrediction(false)}
      />
    </>
  )
}

export default Region
